import React from 'react';
import { IBannerOverlayButton } from '../Helpers/bannerOverlayConfig';
import { elementStyleFrom } from '../Helpers/searchPageConfig';

// The banner overlay's call-to-action button, shared by the home hero carousel (HomePage) and the
// content banner section (BannerSection) — the two rendered it from identical copies of this JSX.
//
// Hover: the resting look is an INLINE style (the merchant's button.style merges over the defaults),
// and an inline style beats any stylesheet rule, so the `.banner-overlay-cta:hover` block in index.css
// can only reach properties the merchant hasn't set inline. Rather than fight that with !important,
// the configured `button.hoverStyle` is merged inline on hover, exactly like the resting style — so a
// merchant's highlight always wins. The class stays on the element so the color-agnostic default
// (brighten + lift + shadow) still applies to stores that configure no hoverStyle of their own.
interface IBannerOverlayCtaProps {
    button: IBannerOverlayButton;
    onActivate: () => void;
}

const BannerOverlayCta: React.FC<IBannerOverlayCtaProps> = ({ button, onActivate }) => {
    const [hovered, setHovered] = React.useState(false);

    return (
        <button
            type='button'
            className='banner-overlay-cta'
            style={{
                pointerEvents: 'auto',
                cursor: 'pointer',
                padding: '12px 28px',
                border: 'none',
                borderRadius: '4px',
                textDecoration: 'none',
                backgroundColor: '#0f6cbd',
                color: '#fff',
                fontWeight: 600,
                fontSize: '1rem',
                // <button> doesn't inherit the page font by default.
                fontFamily: 'inherit',
                ...elementStyleFrom(button.style),
                ...(hovered ? elementStyleFrom(button.hoverStyle) : {}),
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onFocus={() => setHovered(true)}
            onBlur={() => setHovered(false)}
            onClick={(e) => {
                e.stopPropagation();
                onActivate();
            }}
        >
            {button.label}
        </button>
    );
};

export default BannerOverlayCta;
